// Save / share an image from the iOS wrapper's in-app `ImageActions` plugin (ImageActionsPlugin.swift, ART-267).
// Inside the app a browser-style `<a download>` does nothing, so a chat photo's lightbox hands the bytes to native:
// save adds it to Photos, share opens the system share sheet.
import { Capacitor, registerPlugin } from "@capacitor/core";

interface ImageActionsPlugin {
  save(options: { data: string }): Promise<void>;
  share(options: { data: string }): Promise<{ completed?: boolean }>;
}

const ImageActions = registerPlugin<ImageActionsPlugin>("ImageActions");

/** True inside an iOS build that carries the plugin; false on the web and in an older wrapper. */
export function nativeImageActionsAvailable(): boolean {
  return (
    Capacitor.isNativePlatform() && Capacitor.getPlatform() === "ios" && Capacitor.isPluginAvailable("ImageActions")
  );
}

/** Add the image (base64, a `data:` URL is fine) to the photo library. Rejects with code `PHOTOS_DENIED` when the
 *  person has refused Photos access. */
export async function saveImageNative(base64: string): Promise<void> {
  await ImageActions.save({ data: base64 });
}

/** Open the system share sheet for the image. Resolves once the sheet is dismissed. */
export async function shareImageNative(base64: string): Promise<void> {
  await ImageActions.share({ data: base64 });
}
